import { APP_COUNTRY, SANDSIV_ENABLED } from 'config';

export function loadSandsivScript() {
  if (!SANDSIV_ENABLED) return;

  const scriptUrl = getSandsivScriptUrl();

  loadScript(scriptUrl);
}

export function getApiUrl() {
  const sandsivScriptUrl = new URL(getSandsivScriptUrl());
  return sandsivScriptUrl.origin;
}

function getSandsivScriptUrl() {
  switch (APP_COUNTRY) {
    case 'es':
      return 'https://pokerstars-es-digi.sandsiv.com/digi_runner.js';
    case 'pt':
      return 'https://pokerstars-pt-digi.sandsiv.com/digi_runner.js';
    case 'fr':
      return 'https://pokerstars-fr-digi.sandsiv.com/digi_runner.js';
    default:
      return 'https://pokerstars-survey.sandsiv.com/digi_runner.js';
  }
}

function loadScript(src: string) {
  const script = document.createElement('script');
  script.src = src;
  script.defer = true;
  document.body.appendChild(script);
}
